import React, { useEffect, useState } from 'react';
import { useWallet } from '../../context/WalletContext';
import { useNotify } from '../../context/NotificationContext';
import { truncateAddress } from '../../utils/format';
import NeonButton from '../common/NeonButton';

const WalletChip = () => {
  const { account, disconnect } = useWallet();
  const notify = useNotify();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!account) return null;

  const short = truncateAddress(account);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(account);
      setCopied(true);
      notify.success('Copied', 'Address copied to clipboard.');
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };

  return (
    <>
      <button className="wallet-chip compact" onClick={() => setOpen(true)}>
        <span className="dot" />
        <span className="addr-full">{short}</span>
        <span className="addr-short">
          {account.slice(2, 4).toUpperCase()}
        </span>
      </button>

      {open && (
        <>
          <div className="wallet-popover-backdrop" onClick={() => setOpen(false)} />
          <div className="wallet-popover">
            <div className="wallet-popover-head">
              <div className="wp-icon">◆</div>
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--grx-neon)' }}>Connected</div>
                <div className="mono" style={{ fontSize: 11, color: 'var(--grx-text-mute)' }}>Wallet Active</div>
              </div>
            </div>
            <div className="wallet-popover-addr">{account}</div>
            <div className="wallet-popover-actions">
              <NeonButton variant="cyan" size="sm" block onClick={copy}>
                {copied ? '✓ Copied' : 'Copy Address'}
              </NeonButton>
              <NeonButton variant="danger" size="sm" block onClick={() => { setOpen(false); disconnect(); }}>
                Disconnect
              </NeonButton>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default WalletChip;
